import React, { useEffect, useState, useRef } from 'react';

import LinkTo from '../link/Link';
import Logo from './icons/logo.svg';
import LogoUz from './icons/logo-uz.svg';
import Navigation from '../navigation/index';
import { IMenu } from '../../interfaces/menu.interface';
import { IPageContext } from '../../interfaces/pagecontext.interface';
import { ThemeType } from '../../contexts/Theme.model';
import { useTheme } from '../../contexts/Theme.context';

interface Props {
  pageContext: IPageContext;
  menu: IMenu[];
  headerDesktopMenuClass?: string;
}

const Header = ({ menu, pageContext, headerDesktopMenuClass }: Props) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const headerInner = document.getElementById('header-inner');
      const headerInnerTopFallback = 40;
      let headerInnerTop;

      if (headerInner) {
        headerInnerTop = headerInner.offsetTop;
      } else {
        headerInnerTop = headerInnerTopFallback;
      }

      const isScrolled = window.scrollY > headerInnerTop;

      if (isScrolled !== scrolled) {
        setScrolled(!scrolled);
      }
    };

    handleScroll();

    document.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const scrolledClassName = scrolled ? 'sticky' : 'static';

  const { themeType } = useTheme();

  const logoSrc = () => {
    switch (themeType) {
      case ThemeType.enTheme:
        return headerDesktopMenuClass === 'white-background' ? (
          <Logo className="icon-logo-svg black-edition" />
        ) : (
          <Logo />
        );

      case ThemeType.uzTheme:
        return headerDesktopMenuClass === 'white-background' ? (
          <LogoUz className="icon-logo-svg uz-logo black-edition" />
        ) : (
          <LogoUz />
        );

      default:
        return headerDesktopMenuClass === 'white-background' ? (
          <Logo className="icon-logo-svg black-edition" />
        ) : (
          <Logo />
        );
    }
  };

  const navigationRef = useRef<React.ReactElement | null>(null);

  navigationRef.current = navigationRef.current || (
    <Navigation menu={menu} pageContext={pageContext} headerDesktopMenuClass={headerDesktopMenuClass} />
  );

  return (
    <header className={`header ${scrolledClassName}`}>
      <div className="container">
        <div id="header-inner" className="header-inner">
          <LinkTo className="header-logo-link" to="/" pageContext={pageContext}>
            {logoSrc()}
          </LinkTo>
          {navigationRef.current}
        </div>
      </div>
    </header>
  );
};

export default Header;
